export enum IncomeTypeEnum {
    fixedTermEmployment = 'fixedTermEmployment',
    indefinitePeriodEmployment = 'indefinitePeriodEmployment',
    selfEmployment = 'selfEmployment',
    pension = 'pension',
    rentalIncome = 'rentalIncome',
    futureRentalRevenue = 'futureRentalRevenue',
    rentalIncomeOutsideTaxReturn = 'rentalIncomeOutsideTaxReturn',
    childBenefit = 'childBenefit',
    disabilityPension1 = 'disabilityPension1',
    disabilityPension2 = 'disabilityPension2',
    disabilityPension3 = 'disabilityPension3',
    retirementAnnuity = 'retirementAnnuity',
    parentalContribution = 'parentalContribution',
    maternityContribution = 'maternityContribution',
    diet = 'diet',
    orphanPension = 'orphanPension',
    widowPension = 'widowPension',
    alimony = 'alimony',
    actionAgreement = 'actionAgreement',
    indefiniteActionAgreement = 'indefiniteActionAgreement',
    employmentAgreement = 'employmentAgreement',
    indefiniteEmploymentAgreement = 'indefiniteEmploymentAgreement',
    capitalIncome = 'capitalIncome',
    shareOfProfits = 'shareOfProfits',
    turnoverIncome = 'turnoverIncome',
    other = 'other',
    fosterCareAllowance = 'fosterCareAllowance',
    noIncome = 'noIncome',
}
